<button
  (keydown)="onKeyDown($event)"
  type="button"
  (click)="onClick($event)"
  class="add-social-media-button"
  [class.disabled]="isDisabled"
  [disabled]="isDisabled"
  [class.full-width]="fullWidth"
  [class.warning]="asWarning"
>
  {{ label }}
</button>
